<section class="vertical-container-simple column-gap-1">
  <div *ngVar="financialStatement?.gl?.length > 0 as hasGl" class="space-between-horizontal">
    <app-tabs
      *ngIf="fsTabs?.length"
      #tabGroup
      data-qa="fs-tabs"
      [tabNamesRaw]="fsTabs"
      [selectedIndexTab]="selectedTabIndex"
      [isGrey]="true"
      (selectedTabEmitter)="changeTab($event)">
    </app-tabs>
    <ng-container *ngIf="selectedTab === 'Capital accounts' && hasGl">
      <app-button
        *ngIf="!capAccUi.investorsLength"
        data-qa="fs-navbar-manage-investors"
        class="button-font-0p9375"
        [type]="'accent'" [size]="'medium'"
        [bordersSquaredShape]="'full'" [iconName]="'users.svg'"
        [disabled]="capAccUi.isCapAccountManagementLocked || !isAdmin || financialStatement.isCompleted"
        (buttonClick)="fsGetterSetter.isShownManageInvestorsModal.next(true)"
      >
        Manage investors
      </app-button>

      <app-button
        *ngIf="capAccUi.investorsLength > 0"
        data-qa="fs-navbar-ca-bulk-upload-manual-values"
        class="button-font-0p9375"
        [type]="'accent'" [size]="'medium'"
        [bordersSquaredShape]="'full'" [iconName]="'upload.svg'"
        [disabled]="capAccUi.isCapAccountManagementLocked || !isAdmin || financialStatement.isCompleted"
        (buttonClick)="fsGetterSetter.setIsShownBulkUploadManualValues(true);"
      >
        Bulk upload data
      </app-button>
    </ng-container>
  </div>

  <div [ngSwitch]="selectedTab" class="vertical-container-simple column-gap-1">
    <div *ngIf="showEmptyState" class="centered-vertically-column-container min-height-30">
      <!--  isAdmin depends on usertype as usual but also on if entity is Management Comp or Fund
      as Fund period creation is limited to fund service and user can only create period for Mngmnt Company    -->
      <app-empty-state-standard
        data-qa="fs-empty-state"
        [isAdmin]="isManagementEntity ? isAdmin : false"
        [heading]="emptyStateSettings.text.title"
        [description]="emptyStateSettings.text.description"
        [buttonIconName]="emptyStateSettings.buttonSettings?.iconName"
        [buttonText]="emptyStateSettings.buttonSettings?.text"
        (buttonClick)="openCreatePeriodModal()"
      >
      </app-empty-state-standard>
    </div>
    <ng-container *ngIf="periods?.length && fsTabs?.length">
      <ng-container *ngSwitchCase="'General ledger'">
        <div class="main vertical-container-simple column-gap-1p25">
          <div *ngIf="!showEmptyState && financialStatement?.gl" class="font-1 bold600 flex row-gap-0p9375">
            <span >General ledger</span>
            <app-button
              *ngIf="isAdmin && financialStatement?.gl"
              [class.icon-size-0p95]="!isShowUpload"
              [type]="'accent'"
              [size]="'small'"
              [showIcon]="'left'"
              [iconName]="isShowUpload ? 'eye.svg' : 'upload-white.svg'"
              (buttonClick)="isShowUpload = !isShowUpload"
            >
              {{isShowUpload ? "View ledger" : " Reupload "}}
            </app-button>
          </div>
          <app-gl-upload
            *ngIf="isAdmin && (isShowUpload || !financialStatement?.gl)"
            [isLocked]="financialStatement?.isCompleted || !periods">
          </app-gl-upload>
          <app-gl-table
            *ngIf="!isShowUpload && financialStatement?.gl?.length"
            data-qa="existing-gl-view"
            #glTable
            class="green-scroll"
            [quarterlyTransactionsMap]="financialStatement.quarterlyGl"
            (manualEntryEmitter)="manualEntryEmitCatcher($event)"
            (bulkDeleteEmitter)="deleteManualEntries($event)"
            (copyAdjustmentsFromPeriodModal)="copyAdjustmentsSetup()"
          >
          </app-gl-table>
        </div>
      </ng-container>
      <div *ngSwitchCase="'Accounts summary'" class="main vertical-container-simple">
        <app-trial-balance
          [tbData]="financialStatement.tb"
          [isDrilldown]="false"
          [isBooksTab]="true"
          [isLocked]="financialStatement.isCompleted || !isAdmin"
          (manualAccountEmitter)="manualAccountEmitCatcher($event)"
          (bulkDeleteEmitter)="deleteManualAccounts($event)"
        >
        </app-trial-balance>
      </div>
      <div *ngSwitchCase="'Assembly'" class="vertical-container-simple column-gap-1">
        <div class="main" *ngIf="!drillDownPL">
          <app-assembly
            #assemblyBs
            *ngIf="!drillDownPL"
            [isAdmin]="isAdmin"
            [financialStatement]="financialStatement"
            [isPL]='false'
            [isAccountsDrilldown]="drillDownBS"
            (isDrillDownEmitter)="changeDrillDown(true, $event)"
            (scrollChangeEmitter)="scrollChangeCatcher($event)"
            (manualEntryModalEmitter)="openManualEntryModal()"
            (manualAccountEmitter)="manualAccountEmitCatcher($event)"
            (threeDotMenuEmitter)="threeDotMenuEmitterCatcher($event)">
          </app-assembly>
        </div>
        <div class="main" *ngIf="!drillDownBS">
          <app-assembly
            #assemblyPl
            *ngIf="!drillDownBS"
            [isAdmin]="isAdmin"
            [financialStatement]="financialStatement"
            [isPL]='true'
            [isAccountsDrilldown]="drillDownPL"
            (isDrillDownEmitter)="changeDrillDown(false, $event)"
            (scrollChangeEmitter)="scrollChangeCatcher($event)"
            (manualEntryModalEmitter)="openManualEntryModal()"
            (manualAccountEmitter)="manualAccountEmitCatcher($event)"
            (threeDotMenuEmitter)="threeDotMenuEmitterCatcher($event)"
            (plAllocationEmitter)="updateAccumulatedPl($event)">
          </app-assembly>
        </div>
        <div *ngIf="!(drillDownPL || drillDownBS)" class="main">
          <ng-template #noManualEntries>
            <app-empty-state-standard
              data-qa="adjustments-empty-state"
              [isAdmin]="isAdmin && !financialStatement.isCompleted"
              [heading]="'No adjustments yet'"
              [useTwoButtons]="true"
              [buttonIconName]="'plus.svg'"
              [buttonText]="'Add adjustment'"
              [secondButtonText]="'Copy from another period'"
              [secondButtonIconName]="'copy-outline.svg'"
              (buttonClick)="openManualEntryModal()"
              (secondButtonClick)="show.copyAdjustmentsModal = true;">
            </app-empty-state-standard>
          </ng-template>
          <ng-container *ngIf="manualEntries?.length || manualAccounts?.length; else noManualEntries">
            <div class="font-1 bold600 pd-0p5em flex">
              Adjustments
            </div>
            <div class="space-between-horizontal-centered">
              <app-tabs
                #adjTabGroup
                [tabNamesRaw]="adjustmentsTabs"
                [selectedIndexTab]="selectedAdjustmentTabIndex"
                (selectedTabEmitter)="changeTab($event)"
              >
              </app-tabs>
              <div *ngIf="isAdmin" class="end-row-container row-gap-0p5">
                <app-button
                  (buttonClick)="openManualEntryModal()"
                  [type]="'accent'"
                  [size]="'xsmall'"
                  [showIcon]="'left'"
                  [iconName]="'plus.svg'"
                  [disabled]="financialStatement.isCompleted"
                >
                  Adjustment
                </app-button>
              </div>
            </div>
            <div [ngSwitch]="selectedAdjustmentTab" class="mt-1">
              <ng-container *ngSwitchCase="'Manual entries'">
                <app-gl-table
                  *ngIf="manualEntries?.length; else noManualEntries"
                  #glTable
                  class="green-scroll"
                  [manualEntries]="manualEntries"
                  [isManualEntry]="true"
                  (manualEntryEmitter)="manualEntryEmitCatcher($event)"
                  (bulkDeleteEmitter)="deleteManualEntries($event)"
                  (copyAdjustmentsFromPeriodModal)="copyAdjustmentsSetup()">
                </app-gl-table>
              </ng-container>
              <ng-container *ngSwitchCase="'Created accounts'">
                <app-trial-balance
                  *ngIf="manualAccounts?.length; else noManualAccounts"
                  #manualAccountsTable
                  [isManualAccounts]="true"
                  [tbData]="manualAccounts"
                  [isLocked]="financialStatement.isCompleted || !isAdmin"
                  (manualAccountEmitter)="manualAccountEmitCatcher($event)"
                  (bulkDeleteEmitter)="deleteManualAccounts($event)"
                >
                </app-trial-balance>
                <ng-template #noManualAccounts>
                  <app-empty-state-standard [description]="'No manual accounts yet.'"></app-empty-state-standard>
                </ng-template>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
      <div *ngSwitchCase="'Balance sheet'" class="vertical-container-simple column-gap-1">
        <div class="main">
          <app-bs-page
            #bs
            class="vertical-container-simple row-gap-0p25"
            [isAdmin]="isAdmin"
            [financialStatement]="financialStatement"
            (bsDateColumnsChangeEmitter)="updateBsDateColumns($event)">
          </app-bs-page>
        </div>
        <ng-container *ngIf="!bs.show.emptyState && !bs.show.accounts">
          <div *ngIf="bs.parts[2].sums.quarterlySums.size" class="main">
            <app-partners-capital-chart
              [data]="bs.parts[2]"
              [selectedBSDateColumns]="bsColumnsSelectedDates"
              [selectedPeriod]="selectedPeriod"
            />
          </div>
          <div *ngIf="bs.parts[0].sums.quarterlySums.size" class="main">
            <app-assets-chart
              [data]="bs.parts[0]"
              [selectedBSDateColumns]="bsColumnsSelectedDates"
              [selectedPeriod]="selectedPeriod"
            />
          </div>
          <div *ngIf="bs.parts[1].sums.quarterlySums.size" class="main">
            <app-liabilities-chart
              [data]="bs.parts[1]"
              [selectedBSDateColumns]="bsColumnsSelectedDates"
              [selectedPeriod]="selectedPeriod"
            />
          </div>
        </ng-container>
      </div>
      <div *ngSwitchCase="'Profit and loss'" class="vertical-container-simple column-gap-1">
        <div class="main">
          <app-pl-page
            #pl
            [isAdmin]="isAdmin"
            [financialStatement]="financialStatement">
          </app-pl-page>
        </div>
        <ng-container *ngIf="!pl.show.emptyState && !pl.show.accounts">
          <div class="main">
            <app-pl-charts
              [data]="pl.financialStatement.profitLossNetTotals"
              [periodData]="pl.periodsData"
              [selectedPlTabYearly]="pl.selectedPLTab === pl.plTabs[1]"
            >
            </app-pl-charts>
          </div>
          <div *ngIf="pl.parts[0].sums.quarterlySums.size" class="main">
            <app-profits-chart
              [data]="pl.parts[0]"
              [periodData]="pl.periodsData"
              [selectedPlTabYearly]="pl.selectedPLTab === pl.plTabs[1]"
            >
            </app-profits-chart>
          </div>
          <div *ngIf="pl.parts[1].sums.quarterlySums.size" class="main">
            <app-losses-chart
              [data]="pl.parts[1]"
              [periodData]="pl.periodsData"
              [selectedPlTabYearly]="pl.selectedPLTab === pl.plTabs[1]"
            >
            </app-losses-chart>
          </div>
        </ng-container>
      </div>
      <div *ngSwitchCase="'Schedule of investments'" class="vertical-container-simple column-gap-1">
        <app-fs-schedule-of-investments
          #SOI
          class="green-scroll"
          [isLocked]="financialStatement.isCompleted"
          [isAdmin]="isAdmin"
          (differenceAdjustmentEmitter)="catchAdjustmentFromSOI($event)"
          (scrollChangeEmitter)="scrollChangeCatcher($event)"
        >
        </app-fs-schedule-of-investments>
        <div *ngIf="soi?.companySOIs?.length && (manualEntries?.length || manualAccounts?.length)" class="main">
          <div class="font-1 bold600 pd-0p5em flex">
            Adjustments
          </div>
          <div class="space-between-horizontal-centered">
            <app-tabs
              #adjTabGroup
              [tabNamesRaw]="adjustmentsTabs"
              [selectedIndexTab]="selectedAdjustmentTabIndex"
              (selectedTabEmitter)="changeTab($event)"
            >
            </app-tabs>
            <div *ngIf="isAdmin" class="end-row-container row-gap-0p5">
              <app-button
                (buttonClick)="openManualEntryModal()"
                [type]="'accent'"
                [size]="'xsmall'"
                [showIcon]="'left'"
                [iconName]="'plus.svg'"
                [disabled]="financialStatement.isCompleted"
              >
                Adjustment
              </app-button>
            </div>
          </div>
          <div *ngIf="selectedAdjustmentTab === 'Manual entries' && manualEntries.length" class="mt-1">
            <app-gl-table
              data-qa="adjustments-table"
              #glTable
              class="green-scroll"
              [manualEntries]="manualEntries"
              [isManualEntry]="true"
              (manualEntryEmitter)="manualEntryEmitCatcher($event)"
              (bulkDeleteEmitter)="deleteManualEntries($event)"
              (copyAdjustmentsFromPeriodModal)="copyAdjustmentsSetup()"
            >
            </app-gl-table>
          </div>
          <div *ngIf="selectedAdjustmentTab === 'Created accounts' && manualAccounts.length" class="mt-1">
            <app-trial-balance
              [isManualAccounts]="true"
              #manualAccountsTable
              [tbData]="manualAccounts"
              [isLocked]="financialStatement.isCompleted || !isAdmin"
              (manualAccountEmitter)="manualAccountEmitCatcher($event)"
              (bulkDeleteEmitter)="deleteManualAccounts($event)"
            >
            </app-trial-balance>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="'Capital accounts'" class="vertical-container-simple column-gap-1">
        <div class="main">
          <app-capital-account
            class="green-scroll"
            #capitalAccount
            [financialStatement]="financialStatement"
            [isAdmin]="isAdmin"
          >
          </app-capital-account>
        </div>
      </div>
    </ng-container>
  </div>
</section>
<app-create-manual-entry-modal
  *ngIf="show.modalForManualEntry"
  #manualEntryModal
  [accounts]="financialStatement.tb"
  [maxDate]="selectedPeriod"
  [manualEntryForEdit]="manualEntryForEdit"
  (isConfirmedManualEntryCreation)="confirmManualEntry($event)"
  (addManualAccountEmitter)="showModalForAddAccount()">
</app-create-manual-entry-modal>

<app-modal-create-account
  *ngIf="show.addAccountModal"
  #manualAccountModal
  [accounts]="financialStatement.tb"
  [manualAccounts]="manualAccounts"
  [manualAccountForEdit]="manualAccountForEdit"
  (isConfirmedNewAccountCreation)="confirmAddAccount($event, !!manualAccountForEdit)">
</app-modal-create-account>

<app-modal-dialog
  *ngIf="show.deleteModal || show.thinkTwiceModalForStructure"
  [header]="thinkTwiceModalText.title"
  [addAdditionalText]="true"
  [mainText]="[thinkTwiceModalText.description]"
  (isConfirmed)="catchThinkTwiceModalEmit($event)">
</app-modal-dialog>

<app-period-select-modal
  *ngIf="show.copyStructureModal"
  [title]="periodSelectModalText.title"
  [periods]="financialStatementPeriodsForCopy"
  (confirmEmitter)="catchCopyPeriod($event)">
</app-period-select-modal>

<app-modal-container
  *ngIf="show.createPeriodModal"
  class="fix-w-5p5"
  [title]="'Create period'"
  [buttons]="periodCreateModalButtons"
  [applyActivated]="!doesDatePickerDateExist"
  (applyButtonClicked)="createNewPeriod(datePickerDate)"
  (closeButtonClicked)="closeCreatePeriodModal()"
  (dismissButtonClicked)="closeCreatePeriodModal()">
  <app-input-date
    (inputChange)="createPickerDateSelected($event)"
  ></app-input-date>
  <span *ngIf="doesDatePickerDateExist"
        class="modal-subtitle red-10 height-1p875">
    Period already exists.<br> Please select a different date.
  </span>
</app-modal-container>

<app-copy-adjustments-from-period-modal
  data-qa="copy-adjustments-modal"
  *ngIf="show.copyAdjustmentsModal"
  [isAdmin]="isAdmin"
  [selectedPeriod]="selectedPeriod"
  (copyAdjustmentsEmitter)="show.copyAdjustmentsModal = false">
</app-copy-adjustments-from-period-modal>
